<template>
  <div class="ordersEditScreen">
    <b-modal
      :visible="showNewCustomerModal"
      size="xl"
      hide-header
      hide-footer
      cancel-title="Cancelar"
      id="hover-modal"
    >
      <AdminCustomersEditScreen
        :isModal="true"
        id="new"
        @customerAdded="customerAdded"
      />
    </b-modal>

    <ProductModal
      v-if="showModal && selectedProductID.indexOf('PRE_') === -1"
      :productID="selectedProductID"
      :editData="selectedProductData"
      :productDefaultAttributes="selectedProductDefaultAttributes"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showModal = false"
    ></ProductModal>

    <PredefinedProductModal
      v-if="showModal && selectedProductID.indexOf('PRE_') === 0"
      :productID="selectedProductID"
      :editData="selectedProductData"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showModal = false"
    ></PredefinedProductModal>

    <!-- <FreeTextProductModal
      :editData="selectedProductData"
      v-if="showFreeArticleModal"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showFreeArticleModal = false"
    ></FreeTextProductModal> -->
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>
            {{ id === 'new' ? 'Nueva venta' : `Venta ${id}` }}
          </h3>

          <p v-if="isReturn">
            <b-alert show variant="danger">
              <h5>Tramitando devolución</h5>
              <p class="mb-0">
                Recuerda indicar los productos que se van a devolver y no los
                que se queda la clienta.
              </p>
            </b-alert>
          </p>

          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row v-if="!isReturn">
              <b-col cols="12">
                <h4>Datos cliente</h4>
              </b-col>
              <b-form-group
                id="input-customer"
                label="Cliente"
                label-for="customer"
                class="col-4"
              >
                <b-form-row>
                  <multiselect
                    :multiple="false"
                    track-by="value"
                    @input="customersMultiselectChanged"
                    placeholder=""
                    :options="customersMultiselect.loadedOptions"
                    :loading="customersMultiselect.isLoading"
                    label="text"
                    v-model="$v.form.customer.$model"
                  >
                  </multiselect>

                  <small
                    v-if="$v.form.customer.$error"
                    id="input-customer-feedback"
                    class="invalid-customer text-danger"
                  >
                    Este campo es obligatorio.
                  </small>
                </b-form-row>
              </b-form-group>

              <b-form-group class="col-2" label="Fecha">
                <b-form-input
                  v-model="$v.form.created_at.$model"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                v-if="!isReturn"
                id="input-billingAddress"
                class="col-3"
                label="Dirección de facturación"
                label-for="billingAddress"
              >
                <b-form-select
                  :options="billingAddressSelect.loadedOptions"
                  id="billingAddress"
                  @change="billingAddressSelectChanged"
                  v-model="$v.form.billingAddress.$model"
                  :state="validateState('billingAddress')"
                  aria-describedby="input-billingAddress-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-billingAddress-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >

                <b-card
                  class="mt-2"
                  v-if="this.billingAddressSelect.selectedAddress"
                >
                  <span
                    :key="i"
                    v-for="(v, i) in $options.filters.formatBillingAddress(
                      this.billingAddressSelect.selectedAddress
                    )"
                  >
                    {{ v }}<br />
                  </span>
                </b-card>
              </b-form-group>

              <b-form-group
                v-if="!isReturn"
                id="input-created_by"
                class="col-3"
                label="Creado por"
                label-for="created_by"
              >
                <multiselect
                  :multiple="true"
                  track-by="value"
                  placeholder=""
                  :options="employeeProfileMultiSelect.loadedOptions"
                  :loading="employeeProfileMultiSelect.isLoading"
                  label="text"
                  v-model="$v.form.created_by.$model"
                >
                </multiselect>

                <!-- <b-form-select
                  :options="employeeProfileMultiSelect.loadedOptions"
                  id="created_by"
                  v-model="$v.form.created_by.$model"
                  :state="validateState('created_by')"
                  aria-describedby="input-created_by-feedback"
                ></b-form-select> -->

                <b-form-invalid-feedback id="input-created_by-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>
            <b-form-row>
              <b-form-group
                class="col-3"
                id="input-extra_concept"
                v-if="!isReturn"
                label="Concepto aclaratorio"
                label-for="extra_concept"
                description="Añade una línea personalizable en la factura, antes de la tabla de artículos."
              >
                <b-form-input
                  id="extra_concept"
                  v-model="$v.form.extra_concept.$model"
                  :state="validateState('extra_concept')"
                  aria-describedby="input-extra_concept-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-extra_concept-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-voucher"
                class="col-2"
                label="Vale de descuento"
                label-for="voucher"
                v-if="!isReturn"
              >
                <b-form-select
                  :options="
                    id === 'new'
                      ? voucherSelect.loadedOptions.filter((x) => !x.used)
                      : voucherSelect.loadedOptions
                  "
                  id="voucher"
                  :disabled="id !== 'new'"
                  @change="voucherSelectChanged"
                  v-model="$v.form.voucher.$model"
                  :state="validateState('voucher')"
                  aria-describedby="input-voucher-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-voucher-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                v-else
                id="input-voucher"
                class="col-4"
                label="Vale de descuento (devolución)"
                label-for="voucher"
                description="Si se selecciona un vale, el saldo a favor del cliente se sumará al saldo actual del vale. Si se deja en blanco, se creará un nuevo vale."
              >
                <b-form-select
                  :options="voucherSelect.loadedOptions.filter((x) => !x.used)"
                  id="voucher"
                  @change="voucherSelectChanged"
                  v-model="$v.form.voucher.$model"
                  :state="validateState('voucher')"
                  aria-describedby="input-voucher-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-voucher-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                class="col-3"
                id="input-one_liner_grouping_concept"
                v-if="!isReturn"
                label="Concepto agrupación en factura"
                label-for="one_liner_grouping_concept"
                description="Concepto bajo el cual se agruparán todos los productos al generar la factura; si se deja este campo en blanco en blanco, la factura seguirá el formato habitual."
              >
                <b-form-input
                  id="one_liner_grouping_concept"
                  v-model="$v.form.one_liner_grouping_concept.$model"
                  :state="validateState('one_liner_grouping_concept')"
                  aria-describedby="input-one_liner_grouping_concept-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-one_liner_grouping_concept-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                v-if="!isReturn"
                id="input-location"
                class="col-2"
                label="Tienda"
                label-for="location"
              >
                <b-form-select
                  :options="locationSelect.loadedOptions"
                  id="location"
                  disabled
                  v-model="$v.form.location.$model"
                  :state="validateState('location')"
                  aria-describedby="input-location-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-location-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-discountType"
                class="col-2"
                v-if="!isReturn"
                label="Tipo de descuento"
                label-for="discountType"
              >
                <b-form-select
                  :disabled="id !== 'new'"
                  :options="discountTypeSelect.options"
                  id="discountType"
                  v-model="$v.form.discountType.$model"
                  @change="discountTypeChanged"
                  aria-describedby="input-discountType"
                ></b-form-select>
              </b-form-group>
            </b-form-row>

            <b-form-row :class="{ 'pb-3': !isReturn }">
              <b-col cols="12">
                <h4 v-if="!isReturn">Artículos</h4>
                <h4 v-else>Artículos a devolver</h4>
              </b-col>

              <b-col v-if="!isReturn" :cols="8">
                <b-form-group
                  class="col-12 m-0 p-0"
                  id="input-group-product"
                  label=""
                  label-for="group-product"
                  description="Filtro de productos (expresión parcial; mínimo 3 letras; no distingue entre mayúsculas y minúsculas). Ejemplo: 'servi' o 'SERVI' devolverá sólo los productos que contengan la expresión."
                >
                  <multiselect
                    :disabled="isReturn"
                    track-by="uniqueId"
                    :internal-search="false"
                    @search-change="productsFilterChanged"
                    placeholder="Filtro de productos"
                    :options="productsMultiselect.loadedOptions"
                    :loading="productsMultiselect.isLoading"
                    label="text"
                    :preserve-search="true"
                    v-model="form.product"
                  >
                    <template slot="singleLabel" slot-scope="props"
                      ><span class="option__desc"
                        ><span class="option__title">{{
                          props.option.text
                        }}</span></span
                      ></template
                    >
                    <template slot="option" slot-scope="props">
                      <b-row no-gutters class="ms-wrapper">
                        <b-col cols="auto" class="mr-2">
                          <img
                            class="option__image"
                            style="max-height: 100px; max-width: 100px"
                            v-bind:class="{
                              uniqueImg: props.option.images.length === 1,
                              leftImg:
                                props.option.images.length === 2 && index === 0,
                              rightImg:
                                props.option.images.length === 2 && index === 1,
                            }"
                            :src="image"
                            v-for="(image, index) in props.option.images"
                            :key="index"
                        /></b-col>
                        <b-col cols="auto">
                          <div class="option__desc">
                            <span class="option__title">{{
                              props.option.text
                            }}</span
                            ><span class="option__small">{{
                              props.option.desc
                            }}</span>
                          </div>
                          <div>
                            <small
                              :key="attr.label"
                              v-for="(attr, i) in props.option.attributes"
                            >
                              {{ attr.label }}: {{ attr.selector_inputs.name
                              }}<span
                                v-if="i !== props.option.attributes.length - 1"
                                >{{ ',' }}
                              </span>
                            </small>
                          </div></b-col
                        >
                      </b-row>
                    </template>
                  </multiselect></b-form-group
                ></b-col
              >

              <b-col v-if="!isReturn" cols="2">
                <b-form-group
                  class="col-12 m-0 p-0"
                  id="input-group-variationsFilter"
                  label=""
                  label-for="group-variationsFilter"
                  description="Filtro de variaciones (expresión exacta). Ejemplo: tanto 'INDIAN RED' como 'indian red' mostrarán todas las variaciones que contengan un hilo 'Indian Red'"
                >
                  <b-form-input
                    :disabled="productsMultiselect.isLoading"
                    placeholder="Filtro de variaciones"
                    :value="productVariantsFilter"
                    @change="productVariantsFilterChanged"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col v-if="!isReturn" cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  :disabled="isReturn"
                  @click="addArticleToQuoteBtn"
                  >Añadir artículo</b-button
                >
              </b-col>

              <!-- <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  :disabled="id !== 'new'"
                  @click="addFreeTextArticleToQuoteBtn"
                  >Añadir línea libre</b-button
                >
              </b-col> -->
            </b-form-row>

            <div
              v-if="
                form.products.length > 0 && form.productPricesInclTax.length > 0
              "
            >
              <hr />
              <b-form-row>
                <b-form-group class="col-6"> Nombre </b-form-group>
                <b-form-group class="col-1"> Unidades </b-form-group>
                <!--<b-form-group class="col-1"> Precio </b-form-group>-->
                <b-form-group class="col-1"> Subtotal </b-form-group>
                <!--<b-form-group class="col-1"> Suplemento </b-form-group>-->
                <b-form-group class="col-1"> </b-form-group>
              </b-form-row>

              <b-form-row
                :key="i"
                v-for="(product, i) in $v.form.products.$each.$iter"
              >
                <b-form-row class="col-12">
                  <b-form-group class="col-6">
                    <b-form-input
                      :disabled="true"
                      :value="product.reference.$model"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-1">
                    <b-form-input
                      type="text"
                      :value="
                        product.quantity.$model.toString().replace('.', ',')
                      "
                      @change="setDecimalProduct(i, 'quantity', $event)"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-1">
                    <b-form-input
                      type="number"
                      :step="0.01"
                      :disabled="true"
                      :aria-describedby="'input-products-subtotal-' + i"
                      :value="
                        form.productPricesInclTax[i]
                          ? form.productPricesInclTax[i].toFixed(2)
                          : form.productPricesInclTax[i]
                      "
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    v-if="$v.form.discountType.$model !== 'Total'"
                    class="col-1"
                  >
                    <b-input-group>
                      <b-form-input
                        id="productDiscount"
                        :value="form.productDiscounts[i]"
                        @change="changeProductDiscount(i, $event)"
                        :aria-describedby="
                          'input-productDiscounts-subtotal-' + i
                        "
                      ></b-form-input>
                      <template #append>
                        <b-input-group-text>%</b-input-group-text>
                      </template>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group
                    v-if="$v.form.discountType.$model !== 'Total'"
                    class="col-1"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="true"
                        :value="form.productDiscountsAbsolute[i]"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group>
                    <b-button @click="deleteArticle(i)" variant="outline-danger"
                      ><b-icon icon="trash"></b-icon
                    ></b-button>
                    <b-button
                      class="ml-1"
                      @click="editArticle(i)"
                      variant="outline-primary"
                      ><b-icon icon="pencil"></b-icon
                    ></b-button>
                  </b-form-group>
                </b-form-row>

                <b-form-row class="col-12">
                  <ul v-if="product.type.$model !== 'free'" class="col-12">
                    <li
                      :key="j"
                      v-for="(attribute, j) in product.attributes.$each.$iter"
                    >
                      {{ attribute.label.$model }} :
                      {{ attribute.selector_inputs.$model.name }}
                    </li>
                    <li v-if="product.comments.$model" class="comments">
                      Comentarios:
                      <span style="white-space: pre">{{
                        product.comments.$model
                      }}</span>
                    </li>
                  </ul>
                  <ul v-else class="col-12">
                    <li>
                      {{ product.description.$model }}
                    </li>
                    <li v-if="product.comments.$model" class="comments">
                      Comentarios:
                      <span style="white-space: pre">{{
                        product.comments.$model
                      }}</span>
                    </li>
                  </ul>
                </b-form-row>
              </b-form-row>
              <hr />

              <b-form-row>
                <b-form-group class="col-1"> </b-form-group>
                <b-form-group class="col-5"> </b-form-group>
                <b-form-group class="col-1"> </b-form-group>
                <b-col :cols="4">
                  <b-row>
                    <b-col :cols="6">SUBTOTAL</b-col>
                    <b-col :cols="6"
                      >{{ form.totalPriceProductsInclTax.toFixed(2) }} €</b-col
                    >
                  </b-row>

                  <b-row align-v="center">
                    <b-col :cols="6">DESCUENTO</b-col>
                    <b-col :cols="3">-{{ form.discount.toFixed(2) }} €</b-col>
                    <b-col v-if="id === 'new'" :cols="3">
                      <b-input-group size="sm">
                        <b-form-input
                          id="discountPct"
                          :value="$v.form.discountPct.$model.replace('.', ',')"
                          @change="
                            setDecimal('discountPct', $event);
                            changedDiscount();
                          "
                          :state="validateState('discountPct')"
                          aria-describedby="input-discountPct-feedback"
                        ></b-form-input>
                        <template #append>
                          <b-input-group-text>%</b-input-group-text>
                        </template>
                      </b-input-group></b-col
                    >
                  </b-row>

                  <b-row v-if="" align-v="center">
                    <b-col :cols="6">DESCUENTO (VALE)</b-col>
                    <b-col :cols="3"
                      >-{{ form.voucherDiscount.toFixed(2) }} €</b-col
                    >
                  </b-row>

                  <b-row>
                    <b-col :cols="6"
                      ><strong v-if="!isReturn">TOTAL </strong
                      ><strong v-else>TOTAL A DEVOLVER </strong></b-col
                    >
                    <b-col :cols="6"
                      ><strong>{{ totalPrice.toFixed(2) }} €</strong></b-col
                    >
                  </b-row>

                  <div v-if="!isReturn">
                    <b-row class="mt-2">
                      <b-col :cols="12">Pagar con:</b-col>
                      <b-col :cols="12">
                        <b-button-group style="width: 100%">
                          <b-button
                            style="width: 33.33%"
                            @click="payWithCredit()"
                            variant="outline-primary"
                            size="sm"
                            ><b-icon icon="credit-card"></b-icon> Tarjeta
                            crédito</b-button
                          >
                          <b-button
                            style="width: 33.33%"
                            @click="payWithTransfer()"
                            variant="outline-primary"
                            size="sm"
                            ><b-icon icon="bank2"></b-icon>
                            Transferencia</b-button
                          >
                          <b-button
                            style="width: 33.33%"
                            @click="payWithCash()"
                            size="sm"
                            variant="outline-primary"
                            ><b-icon icon="cash-coin"></b-icon>
                            Efectivo</b-button
                          >
                        </b-button-group>
                      </b-col>
                      <b-col cols="12">
                        <b-input-group>
                          <b-form-input
                            :value="form.amtPaidCredit"
                            @change="setDecimal('amtPaidCredit', $event)"
                          ></b-form-input>

                          <b-form-input
                            :value="form.amtPaidTransfer"
                            @change="setDecimal('amtPaidTransfer', $event)"
                          ></b-form-input>

                          <b-form-input
                            :value="form.amtPaidCash"
                            @change="setDecimal('amtPaidCash', $event)"
                          ></b-form-input>
                        </b-input-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col
                        v-if="
                          parseFloat(pendingAmt.toFixed(2)) > 0.0 ||
                          parseFloat(pendingAmt.toFixed(2)) < 0.0
                        "
                        :cols="12"
                        class="text-danger"
                        >Pendiente: {{ pendingAmt.toFixed(2) }} €
                        <div v-if="parseFloat(pendingAmt.toFixed(2)) < 0.0">
                          (se generará un vale de devolución por valor de
                          {{ (pendingAmt * -1).toFixed(2) }} €)
                        </div>
                      </b-col>
                      <b-col v-else class="text-success"
                        >Pendiente: 0.00 €</b-col
                      >
                    </b-row>
                  </div>

                  <!-- <b-row
                    class="text-success"
                    v-if="form.amtPaid.toFixed(2) === totalPrice.toFixed(2)"
                  >
                    <b-col :cols="6"></b-col>
                    <b-col :cols="6"><strong>PAGADO</strong></b-col>
                  </b-row> -->

                  <!-- <div v-if="form.amtPaid.toFixed(2) !== totalPrice.toFixed(2)">
                    <b-row>
                      <b-col :cols="6">ABONADO</b-col>
                      <b-col :cols="6">{{ form.amtPaid.toFixed(2) }} €</b-col>
                    </b-row>

                    <b-row class="text-warning">
                      <b-col :cols="6"
                        ><strong>PENDIENTE ABONAR</strong>
                        <div>
                          <small>
                            (a favor de
                            {{
                              pendingAmt > 0 ? 'From Bea' : 'el cliente'
                            }})</small
                          >
                        </div>
                      </b-col>
                      <b-col :cols="3"
                        ><strong>{{ pendingAmt.toFixed(2) }} €</strong></b-col
                      >
                      <b-col :cols="3">
                        <b-button
                          @click="markAsPaid"
                          block
                          size="sm"
                          variant="secondary"
                        >
                          Saldado</b-button
                        >
                      </b-col>
                    </b-row>
                  </div> -->
                </b-col>
              </b-form-row>
            </div>

            <b-form-row class="mt-2">
              <b-col :cols="12">
                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="pendingAmtPositive"
                >
                  {{
                    id === 'new'
                      ? 'Guardar nueva venta'
                      : isReturn
                      ? 'Crear devolución'
                      : 'Guardar venta'
                  }}</b-button
                >
              </b-col>
              <b-col v-if="pendingAmtPositive" :cols="12">
                <small class="gray-text text-danger mt-1"
                  >Debes cobrar correctamente para poder guardar la
                  venta.</small
                >
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  numeric,
  minValue,
  decimal,
  requiredIf,
} from 'vuelidate/lib/validators';
import ProductModal from '@/admin/components/orders/ProductModal.vue';
import PredefinedProductModal from '@/admin/components/quotes/PredefinedProductModal.vue';

import OpenOrdersModal from '@/admin/components/orders/OpenOrdersModal.vue';

// import FreeTextProductModal from '@/admin/components/quotes/FreeTextProductModal.vue';

import AdminCustomersEditScreen from '@/admin/screens/customers/AdminCustomersEditScreen.vue';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import * as Sentry from '@sentry/browser';
import Multiselect from 'vue-multiselect';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'AdminOrdersEditScreen',
  props: ['id', 'location', 'isReturn'],

  components: {
    Multiselect,
    ProductModal,
    PredefinedProductModal,
    // PredefinedProductModal,
    // FreeTextProductModal,
    AdminCustomersEditScreen,
    OpenOrdersModal,
  },
  mixins: [validationMixin],
  validations() {
    let rules = {
      created_at: {},
      customer: {},
      extra_concept: {},
      one_liner_grouping_concept: {},

      billingAddress: {},

      productPricesInclTax: {
        required,
      },
      productPricesExclTax: {
        required,
      },
      created_by: {},
      location: {
        required,
      },
      productDiscounts: {},
      productDiscountsAbsolute: {},
      discountType: {
        required,
      },
      discount: {
        required,
      },
      voucherDiscount: {
        required,
      },
      discountPct: {
        required,
      },

      totalPriceProductsInclTax: {
        required,
      },
      totalPriceProductsExclTax: {
        required,
      },
      taxPrice: {
        required,
      },
      amtPaid: {
        required,
      },
      amtPaidCredit: {
        required,
      },
      amtPaidTransfer: {
        required,
      },
      amtPaidCash: {
        required,
      },
      products: {
        $each: {
          reference: {
            required,
          },
          attributes: {
            $each: {
              selector_inputs: {
                required,
              },
              extra_info: {},
              label: {
                required,
              },
              reference: {
                // May be empty for predefined products
              },
            },
          },
          description: {},
          comments: {},
          quantity: {
            required,
          },
          type: {
            required,
          },
        },
      },
      voucher: {},
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      customer: null,

      billingAddress: null,

      product: null,
      products: [],
      productPricesInclTax: [],
      productPricesExclTax: [],
      productDiscounts: [],
      productDiscountsAbsolute: [],
      discountType: 'Total',
      discount: 0.0,
      voucherDiscount: 0.0,
      discountPct: '0.0',
      totalPriceProductsInclTax: 0.0,
      totalPriceProductsExclTax: 0.0,

      voucher: null,
      created_by: [],
      taxPrice: 0.0,
      productHashes: [],
      extra_concept: '',
      created_at: moment().format('DD-MM-YYYY HH:mm'),
      one_liner_grouping_concept: '',
      // password: '',
      // password_confirmation: '',
      location: null,
      amtPaid: 0.0,
      amtPaidCredit: '0.0',
      amtPaidTransfer: '0.0',
      amtPaidCash: '0.0',
      error: {
        show: false,
        text: '',
      },
    };

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,

      customersMultiselect: {
        loadedOptions: [],
        isLoading: false,
      },
      productsMultiselect: {
        loadedOptions: [],
        isLoading: false,
      },
      productVariantsFilter: '',
      productFilter: '',
      productsMultiselectInterval: false,
      employeeProfileMultiSelect: {
        loadedOptions: [],
        isLoading: false,
      },
      billingAddressSelect: {
        loadedOptions: [],
        selectedAddress: null,
      },
      voucherSelect: {
        loadedOptions: [],
        selectedAddress: null,
      },
      locationSelect: {
        loadedOptions: [],
      },

      discountTypeSelect: {
        options: [
          { text: 'Global', value: 'Total' },
          { text: 'Por producto', value: 'Per-product' },
        ],
      },
      selectedProductID: null,
      selectedProductData: null,
      showModal: false,
      showFreeArticleModal: false,
      showNewCustomerModal: false,
      // orderStatusHistories: [],
      selectedStatus: null,
    };
  },
  computed: {
    pendingAmtPositive() {
      return (
        parseFloat(this.pendingAmt.toFixed(2)) > 0.0

        // ||        parseFloat(this.pendingAmt.toFixed(2)) < 0.0
      );
    },
    pendingAmt() {
      return (
        this.totalPrice -
        parseFloat(this.form.amtPaidCredit ? this.form.amtPaidCredit : '0.00') -
        parseFloat(
          this.form.amtPaidTransfer ? this.form.amtPaidTransfer : '0.00'
        ) -
        parseFloat(this.form.amtPaidCash ? this.form.amtPaidCash : '0.00')
      );
    },
    totalPrice() {
      return (
        parseFloat(this.form.totalPriceProductsInclTax) -
        parseFloat(this.form.discount) -
        parseFloat(this.form.voucherDiscount)
      );
    },
  },
  created() {
    this.productsMultiselect.isLoading = true;
    this.customersMultiselect.isLoading = true;

    let promises = [];

    promises.push(actions.getCustomersUnpaginated());
    // promises.push(actions.getProductsWithStock(this.location));
    // promises.push(actions.getPredefinedProductsWithStock(this.location));
    promises.push(actions.getLocationsUnpaginated());
    promises.push(actions.getEmployees());
    promises.push(actions.getActiveVouchers(this.location));

    Promise.all(promises).then((x) => {
      this.customersMultiselect.loadedOptions = x[0].data.results.map((x) => {
        return {
          text: x.full_name + (x.email ? ' (' + x.email + ')' : ''),
          value: x.id,
          default_discount: x.default_discount,
          email: x.email ? x.email : '',
        };
      });
      this.customersMultiselect.isLoading = false;

      // this.productsMultiselect.loadedOptions = [];

      this.updateProductsMultiselect();

      // x[1].data.results.map((y) => {
      //   y.stockline_set.map((z) => {
      //     this.productsMultiselect.loadedOptions.push({
      //       text: y.reference,
      //       value: y.id,
      //       uniqueId: z.id,
      //       attributes: z.product_attributes,
      //       images: z.product_images,
      //     });
      //   });
      // });

      // x[2].data.results.map((y) =>
      //   y.stockline_set.map((z) => {
      //     this.productsMultiselect.loadedOptions.push({
      //       text: y.reference,
      //       value: 'PRE_' + y.id,
      //       uniqueId: z.id,
      //       attributes: z.product_attributes,
      //     });
      //   })
      // );

      // Employees
      this.employeeProfileMultiSelect.loadedOptions = x[2].data.results.map(
        (x) => {
          return {
            text: x.first_name + ' ' + x.last_name,
            value: x.id,
            works_here_today: x.workschedule_set.some(
              (xxx) =>
                xxx.day_of_week === moment().locale('en').format('dddd') &&
                xxx.location === this.location
            ),
            located_here: x.workschedule_set.some(
              (xxx) => xxx.location === this.location
            ),
          };
        }
      );

      const employeesWorkingHereToday = this.employeeProfileMultiSelect.loadedOptions.filter(
        (xxx) => xxx.works_here_today === true
      );

      const employeesLocatedHere = this.employeeProfileMultiSelect.loadedOptions.filter(
        (xxx) => xxx.located_here === true
      );

      // console.log(someEmployeeWorkingToday);
      this.employeeProfileMultiSelect.loadedOptions = [
        ...new Set([...employeesWorkingHereToday, ...employeesLocatedHere]),
      ];

      if (employeesWorkingHereToday) {
        this.form.created_by = employeesWorkingHereToday;
      }

      this.voucherSelect.loadedOptions = x[3].data.results.map((x) => {
        return {
          text: x.code,
          value: x.id,
          code: x.code,
          discount: x.discount,
          customer: x.customer,
          used: x.used,
          location: x.location,
        };
      });

      // if (someEmployeeWorkingToday >= 0) {
      //   this.form.created_by = this.employeeProfileMultiSelect.loadedOptions[
      //     someEmployeeWorkingToday
      //   ].value;
      // }

      this.productsMultiselect.isLoading = false;

      // actions.getOrderStatusHistoriesByOrder(this.id).then((response6) => {
      //   this.orderStatusHistories = response6.data.results;
      // });

      // Location
      this.locationSelect.loadedOptions = x[1].data.results.map((x) => {
        return {
          text: x.name,
          value: x.id,
        };
      });

      this.form.location = this.location;

      if (this.id !== 'new') {
        actions.getOrder(this.id).then((response2) => {
          const data = response2.data;

          this.form.billingAddress = data.billing_address;

          this.form.created_at = data.created_at;

          this.form.products = data.products;

          this.form.productPricesInclTax = data.product_prices_incl_tax;
          this.form.productPricesExclTax = data.product_prices_excl_tax;
          this.form.productDiscounts = data.product_discounts;
          this.form.productDiscountsAbsolute = data.product_discounts_absolute;

          this.form.productHashes = data.product_hashes;

          this.form.voucher = data.voucher;
          this.form.voucherDiscount = parseFloat(data.voucher_discount);

          // this.form.created_by = data.created_by;

          this.form.created_by = this.employeeProfileMultiSelect.loadedOptions.filter(
            (x) => data.created_by.includes(x.value)
          );

          this.form.taxPrice = parseFloat(data.tax_price);

          this.form.discountPct = data.discount_pct;
          this.form.discount = parseFloat(data.discount);
          this.form.discountType = data.discount_type;

          this.form.amtPaidCredit = data.amt_paid_credit;
          this.form.amtPaidTransfer = data.amt_paid_transfer;
          this.form.amtPaidCash = data.amt_paid_cash;

          this.form.location = data.location;

          this.form.totalPriceProductsInclTax = parseFloat(
            data.totalprice_products_incl_tax
          );

          this.form.totalPriceProductsExclTax = parseFloat(
            data.totalprice_products_excl_tax
          );

          this.selectedStatus = data.status;

          this.form.extra_concept = data.extra_concept;

          this.form.one_liner_grouping_concept =
            data.one_liner_grouping_concept;

          this.form.amtPaid = parseFloat(data.amt_paid);

          actions.getCustomer(data.customer).then((response3) => {
            const data = response3.data;

            this.form.customer = this.customersMultiselect.loadedOptions.find(
              (x) => x.value === data.id
            );
          });

          actions
            .getBillingAddressesByCustomer(data.customer, 0)
            .then((response5) => {
              this.billingAddressSelect.loadedOptions = response5.data.results.map(
                (x) => {
                  return {
                    text: x.name,
                    value: x.id,
                  };
                }
              );

              if (this.form.billingAddress) {
                this.billingAddressSelectChanged(
                  this.billingAddressSelect.loadedOptions.find(
                    (yy) => yy.value === this.form.billingAddress
                  ).value
                );
              }
            });
        });
      } else {
        // pepe
      }
    });
  },
  filters: {
    formatStatus: function (value) {
      return {
        Received: 'Recibido',
        Workshop: 'En taller',
        Finished: 'Terminado',
        Sent: 'Enviado',
        Delivered: 'Entregado',
      }[value];
    },
    formatBillingAddress: function (billingAddress) {
      const {
        first_name,
        last_name,
        street_address,
        postal_code,
        city,
        country,
        company_name,
        company_id,
      } = billingAddress;

      let lines = [];
      lines.push(`${first_name} ${last_name}`);
      lines.push(`${street_address}`);
      lines.push(`${city} (${postal_code})`);
      lines.push(`${country}`);

      return lines;
    },
  },
  methods: {
    productVariantsFilterChanged(search) {
      if (search.length <= 2 && search.length !== 0) {
        return false;
      }

      this.productVariantsFilter = search;

      this.updateProductsMultiselect();
    },
    payWithCredit() {
      if (this.totalPrice > 0.0) {
        this.form.amtPaidCredit = this.totalPrice.toFixed(2);
        this.form.amtPaidTransfer = '0.0';
        this.form.amtPaidCash = '0.0';
      }
    },
    payWithTransfer() {
      if (this.totalPrice > 0.0) {
        this.form.amtPaidTransfer = this.totalPrice.toFixed(2);
        this.form.amtPaidCredit = '0.0';
        this.form.amtPaidCash = '0.0';
      }
    },
    payWithCash() {
      if (this.totalPrice > 0.0) {
        this.form.amtPaidCash = this.totalPrice.toFixed(2);
        this.form.amtPaidCredit = '0.0';
        this.form.amtPaidTransfer = '0.0';
      }
    },
    changeProductDiscount(i, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.form.productDiscounts[i] = val;

      this.quotePrice();
    },

    markAsPaid() {
      this.form.amtPaid = this.totalPrice;
    },
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    setDecimalProduct(i, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.products.$each.$iter[i][name].$model = val;
      this.$v.form.products.$each.$iter[i][name].$touch();
      this.quotePrice();
    },
    customerAdded(idCustomer) {
      actions.getCustomersUnpaginated().then((response) => {
        this.customersMultiselect.loadedOptions = response.data.results.map(
          (x) => {
            return {
              text: x.full_name + ' (' + x.user.email + ')',
              value: x.id,
            };
          }
        );
        this.customersMultiselect.isLoading = false;
        this.form.customer = this.customersMultiselect.loadedOptions.find(
          (x) => x.value === idCustomer
        );
        this.showNewCustomerModal = false;
      });
    },
    newCustomerModal() {
      this.showNewCustomerModal = true;
    },
    changedDiscount() {
      this.quotePrice();
    },

    quotePrice() {
      let data = {};

      data['customer'] = this.form.customer ? this.form.customer.value : null;
      data['billing_address'] = this.form.billingAddress;

      data['products'] = this.form.products;

      data['discount_pct'] = this.form.discountPct;

      data['product_discounts'] = this.form.productDiscounts;

      actions.postOrderPrice(data).then((x) => {
        // if (onlyUpdateDiscount) {
        //   this.form.discount = x.data.discount;
        //   this.form.isDiscountOverTax = x.data.isDiscountOverTax;
        //   this.form.taxPrice = x.data.taxPrice;
        // } else
        this.form.productPricesInclTax = x.data.productPricesInclTax;
        this.form.productPricesExclTax = x.data.productPricesExclTax;
        this.form.productDiscountsAbsolute = x.data.productDiscountsAbsolute;

        this.form.productHashes = x.data.productHashes;

        this.form.discount = x.data.discount;

        this.form.totalPriceProductsInclTax = x.data.totalPriceProductsInclTax;

        this.form.totalPriceProductsExclTax = x.data.totalPriceProductsExclTax;

        this.form.taxPrice = x.data.taxPrice;
      });
    },
    cancelAddProduct() {
      this.showModal = false;
    },
    editProduct(productData, attributes, currentPrice, qty, comments, images) {
      const editedArticleIndex = this.articleCurrentIndex;

      this.form.products.splice(editedArticleIndex, 1, {
        reference: productData.reference,
        // attributes: attributes.map((x, i) => {
        //   return {
        //     name: x.label,
        //     txtValue: x.selector_inputs.name,
        //     value: x.selector_inputs.value,
        //   };
        // }),
        attributes: attributes.map(function (item) {
          delete item.selector_options;

          if (item.reference === 'BORDADO') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'INICIALES') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'TELA') {
            delete item.extra_info.fabricsInfo;
          }

          if ('initial_value' in item) {
            delete item.initial_value;
          }

          return item;
        }),
        quantity: qty,
        type: productData.type,
        price: currentPrice,
        id: productData.id,
        description: productData.type === 'free' ? productData.description : '',
        comments: comments,
        images: images,
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.quotePrice();

      this.showFreeArticleModal = false;

      this.showModal = false;
    },
    addProduct(productData, attributes, currentPrice, qty, comments, images) {
      this.showModal = false;
      this.showFreeArticleModal = false;

      if (this.form.discountType === 'Per-product') {
        this.form.productDiscounts.push('0');
        this.form.productDiscountsAbsolute.push('0');
      }

      this.form.products.push({
        reference: productData.reference,
        attributes: attributes.map(function (item) {
          delete item.selector_options;

          if (item.reference === 'BORDADO') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'INICIALES') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'TELA') {
            delete item.extra_info.fabricsInfo;
          }

          if ('initial_value' in item) {
            delete item.initial_value;
          }

          return item;
        }),
        quantity: qty,
        type: productData.type,
        price: currentPrice,
        id: productData.id,
        description: productData.type === 'free' ? productData.description : '',
        comments: comments,
        images: images,
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.quotePrice();
    },
    deleteArticle(articleIndex) {
      this.form.products.splice(articleIndex, 1);
      this.quotePrice();
    },
    editArticle(articleIndex) {
      this.selectedProductID = this.form.products[articleIndex].id.toString();

      if (this.form.products[articleIndex].type === 'predefined') {
        this.selectedProductID = 'PRE_' + this.selectedProductID;
      }

      this.selectedProductData = this.form.products[articleIndex];
      this.articleCurrentIndex = articleIndex;

      if (this.selectedProductID === '0') {
        this.showFreeArticleModal = true;
      } else {
        this.showModal = true;
      }
    },
    addFreeTextArticleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showFreeArticleModal = true;
    },
    addArticleToQuoteBtn() {
      this.selectedProductID = this.form.product.value.toString();
      this.selectedProductDefaultAttributes = this.form.product.attributes;
      this.selectedProductData = null;

      this.showModal = true;
    },
    discountTypeChanged(val) {
      if (val === 'Per-product') {
        let arr = [];
        for (let index = 0; index < this.form.products.length; index++) {
          arr.push('0');
        }

        this.form.productDiscounts = arr;
        this.form.productDiscountsAbsolute = arr;

        this.form.discountPct = '0';
        this.form.discount = 0;
      } else {
        this.form.discountPct = '0';
        this.form.discount = 0;
      }
    },
    voucherSelectChanged(val) {
      if (!this.isReturn) {
        const elem = this.voucherSelect.loadedOptions.find(
          (x) => x.value === this.form.voucher
        );
        const discount = elem.discount;
        this.form.voucherDiscount = parseFloat(discount);

        this.form.amtPaidCredit = '0.0';
        this.form.amtPaidCash = '0.0';
        this.form.amtPaidTransfer = '0.0';
      }
    },
    billingAddressSelectChanged(val) {
      actions.getBillingAddress(val).then((z) => {
        this.billingAddressSelect.selectedAddress = z.data;
      });
    },

    customersMultiselectChanged(selectedOption, id) {
      if (selectedOption === null) {
        this.form.discountPct = '0';
        this.form.discount = 0;

        this.form.billingAddress = null;
        this.billingAddressSelect.loadedOptions = [];

        return;
      }

      this.setDecimal(
        'discountPct',
        selectedOption.default_discount.replace('.', ',')
      );
      this.changedDiscount();

      actions
        .getBillingAddressesByCustomer(selectedOption.value, 0)
        .then((y) => {
          this.billingAddressSelect.loadedOptions = y.data.results.map((x) => {
            return {
              text: x.name,
              value: x.id,
            };
          });
        });
    },

    updateProductsMultiselect() {
      console.log(
        'FILTERS CHANGED',
        this.productFilter,
        this.productVariantsFilter
      );

      if (this.productsMultiselectInterval) {
        clearInterval(this.productsMultiselectInterval);
        console.log('Cancelled previous interval');
      }

      this.productsMultiselectInterval = setTimeout(() => {
        console.log('Executing now');
        this.productsMultiselect.isLoading = true;
        let promises = [];
        promises.push(
          actions.getProductsWithStockGlobalSearch(
            this.location,
            this.productFilter,
            this.productVariantsFilter
          )
        );
        promises.push(
          actions.getPredefinedProductsWithStockGlobalSearch(
            this.location,
            this.productFilter
          )
        );
        Promise.all(promises).then((x) => {
          this.productsMultiselect.loadedOptions = [];

          x[0].data.results.map((y) => {
            y.stockline_set.map((z) => {
              this.productsMultiselect.loadedOptions.push({
                text: y.reference + '(' + z.id + ')',
                value: y.id,
                uniqueId: z.id,
                attributes: z.product_attributes,
                images: z.product_images,
              });
            });
          });

          x[1].data.results.map((y) =>
            y.stockline_set.map((z) => {
              this.productsMultiselect.loadedOptions.push({
                text: y.reference,
                value: 'PRE_' + y.id,
                uniqueId: z.id,
                attributes: z.product_attributes,
              });
            })
          );

          this.productsMultiselect.isLoading = false;
          this.productsMultiselectInterval = false;
        });
      }, 1500);
    },

    productsFilterChanged(query) {
      if (query.length !== 0 && query.length <= 2) {
        return false;
      }

      this.productFilter = query;

      this.updateProductsMultiselect();
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateProduct(index, field) {
      const { $dirty, $error } = this.$v.form.products.$each[index][field];
      return $dirty ? !$error : null;
    },

    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {};

      data['customer'] = this.form.customer ? this.form.customer.value : null;

      data['billing_address'] = this.form.billingAddress;

      data['products'] = this.form.products;

      data['created_at'] = this.form.created_at;

      data['product_prices_incl_tax'] = this.form.productPricesInclTax;
      data['product_discounts'] = this.form.productDiscounts;
      data['product_discounts_absolute'] = this.form.productDiscountsAbsolute;
      data['discount_type'] = this.form.discountType;

      if (!this.isReturn) {
        data['created_by'] = this.form.created_by.map((x) => x.value);
      }

      data['product_prices_excl_tax'] = this.form.productPricesExclTax;

      data['discount_pct'] = this.form.discountPct;
      data['discount'] = this.form.discount.toFixed(4);

      data['voucher_discount'] = this.form.voucherDiscount.toFixed(4);
      data['voucher'] = this.form.voucher;

      data['tax_price'] = this.form.taxPrice.toFixed(4);

      data[
        'totalprice_products_incl_tax'
      ] = this.form.totalPriceProductsInclTax.toFixed(4);
      data[
        'totalprice_products_excl_tax'
      ] = this.form.totalPriceProductsExclTax.toFixed(4);

      data['extra_concept'] = this.form.extra_concept;

      data['one_liner_grouping_concept'] = this.form.one_liner_grouping_concept;

      data['amt_paid'] = this.form.amtPaid.toFixed(2);

      data['product_hashes'] = this.form.productHashes;

      data['total_price'] = this.totalPrice.toFixed(2);

      data['location'] = this.form.location;

      data['amt_paid_credit'] = this.form.amtPaidCredit;
      data['amt_paid_transfer'] = this.form.amtPaidTransfer;
      data['amt_paid_cash'] = this.form.amtPaidCash;

      data['is_return'] = this.isReturn ? 1 : 0;

      Sentry.setExtra('data', JSON.stringify(data));

      if (this.id !== 'new') {
        actions.patchOrder(this.id, data).then((x) => {
          this.$router.push({ name: 'AdminOrdersScreen' });
        });
      } else {
        actions.postOrder(data).then((x) => {
          this.$router.push({ name: 'AdminOrdersScreen' });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.comments {
  margin-top: 0.2rem;
  font-style: italic;
}

.ms-wrapper {
  align-items: center;
}
</style>
